<template>
  <div id="login">
    <v-container class="l-wrapper pb-0">
      <v-row justify="space-around" class="mt-7">
        <v-sheet width="700" elevation="8"  >
          <v-row justify="space-around">
              <div class="logo pt-4">
                <img :src="require('../../assets/logos/logo-pict-black.svg')" />
                <h2 class="ml-1 login-header">
                  REVELES
                </h2>
              </div>
          </v-row>
          <v-container>
          <v-row class="d-flex flex-column align-center mt-4 px-12">
            <v-col col="12" lg="12" md="12" sm="12">
              <label class="login-label">Log In</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12" lg="12" md="12" sm="12">
              <v-form v-model="valid" class="justify-end px-12 py-4" >
                <v-text-field
                  label="Email"
                  v-model="email"
                  :rules="emailRules"
                  required
                  validate-on-blur
                  class="mb-5"
                >
                </v-text-field>
                <v-text-field
                  label="Password"
                  v-model="password"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  validate-on-blur
                  v-on:keyup.enter="submit"
                >
                </v-text-field>
                <div class="d-flex flex-row justify-end">
                  <v-btn
                    color="#4C86FD"
                    class="save-btn login-btn mt-4"
                    depressed
                    @click="submit"
                    tile
                  >
                    Log In
                  </v-btn>
                </div>
              </v-form>
              <div class="login-footer">
                <div v-for="data in footerData" :key="data.header">
                  <span>{{data.header}}</span>
                  <a
                   class="forgot-pass text-style pl-1"
                   @click="$router.push(data.route)"
                  >
                    {{ data.anchorText }}
                  </a>
                  <v-icon small color="#3271c4">play_arrow</v-icon>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 mt-n8" justify="space-around" style="color:#76a1d8">
              version: {{ version }}
          </v-row>
          </v-container>
        </v-sheet>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      password: '',
      passwordRules: {
        required: value => !!value || 'Password is required.',
        min: v => v.length >= 8 || 'Min 8 characters'
      },
      showPassword: false,
      loading: false,
      footerData: [
        {
          header: 'Forgot your password?',
          route: '/session/reset-password',
          anchorText: 'Reset your password'
        }
      //   {
      //     header: 'Don’t have an account?',
      //     route: '/session/signup',
      //     anchorText: 'Sign up'
      //   }
      ],
      version: this.$appVersion
    }
  },
  methods: {
    async submit () {
      const redirect = this.$route.query.redirect
      const user = {
        username: this.email,
        password: this.password,
        redirect: redirect || '/',
        refresh: true
      }
      this.$store.dispatch('signInUserApi', user)
    }
  },
  watch: {}
}
</script>

<style lang="scss">
  .v-text-field input {
    color: #212338 !important;
    font-family: "gt_america";
    font-size: 18px !important;
    letter-spacing: 0;
    font-weight: bold;
  }
  .v-text-field__slot {
    padding: 5px 0px;
  }
  .v-text-field label {
    color: #212338 !important;
    font-family: "gt_america";
    font-size: 18px !important;
    letter-spacing: 0;
    line-height: 46px;
    font-weight: bold;
  }
  #login {
    background-color: #ffffff;
    height: 100%;
    background-size: cover;
    padding: 50px 0 0 0;
    .wrapper {
      display: flex;
      flex-direction: column;
      .content-wrapper {
        flex: 1;
      }
      .shapes-wrapper {
        flex: 1;
      }
    }
    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }

    .login-footer {
      margin-bottom: 30px;
      color: $dark-gray-color;
      text-align: center;
      a {
        color: #76a1d8;
        text-decoration: underline;
      }
    }
    .l-wrapper {
      overflow: hidden;
      position: relative;
      min-height: 100%;

      img {
        width: 42px;
        height:  42px;
      }

      .v-avatar {
        position: relative;
        background: #fff;
        border-radius: 50%;
        top: -29px;
      }
    }
    .shapes {
      height: 580px;
      .shape-1 {
        position: absolute;
        height: 580px;
        bottom: -100px;
      }
      .shape-2 {
        position: absolute;
        height: 180px;
        bottom: 60px;
      }
    }
    .login-label {
      color: #212338;
      font-family: "gt_america";
      font-size: 24px;
      letter-spacing: 0;
      line-height: 30px;
      font-weight: bold;
    }
    .login-btn {
      width: 120px;
    }
  }
</style>
